import { ISingleIdParams } from '../types/actionParams';
import { IViewActions } from '../types/IViewActions';
import { Request } from './Request';

export class GetViewActionsRequest extends Request<ISingleIdParams, IViewActions> {
  constructor(id: string) {
    super('getViewActions', { id: id });
  }
}
